/**
 * Interfaces for cards
 * @version 20.12.2018 (413170c)
 * @see https://intelingu-apidocs.staging.mhm-dev.net/index.html
 */
import { AchievementModel } from './AchievementModel';

export interface CourseModel {
    source_language_code: string;
    source_language_name: string;
    translation_language_code: string;
    translation_language_name: string;
}

export interface WordTranslationModel {
    source_word_lemma: string;
    translation_word_lemma: string;
    audio: string;
}

export interface ExampleSentenceModel {
    sentence: string;
    translation: string;
    audio: string;
    disabled?: boolean;
}

export interface MnemoModel {
    keyword: string;
    sentence: string;
    short_sentence: string;
    disabled?: boolean;
}

export interface TopicModel {
    id?: number;
    source_id?: number;
    title: string;
    // rule?: string;
    // explanation?: string;
    // examples?: string;
    description: string;
    related?: Array<{ id: string; name: string }>;
}

export interface ExplanationModel {
    content: string;
    solutions: string[];
}

export interface ExerciseModel {
    content: string;
    solution: string;
    false_answers: string[];
    translation: string;
}

/**
 * Cards
 */

export interface PreloadBufferItem {
    previousCard: CardModel;
    nextCard: CardModel;
    skippedPosition?: number;
    achievement?;
}

export interface CardModel {
    id?: number;
    card_type: CardType;
    course?: CourseModel;
    topic?: TopicModel;
    achievement?: AchievementModel;
    is_new: boolean;
    word_rank?: number;
    is_first_topic_show?: boolean;
    expired?: boolean;
}

export interface VocabularyCardModel extends CardModel {
    word_translation: WordTranslationModel;
    example_sentences: ExampleSentenceModel[];
    info?: string;
    derivable_from_words: string;
    mnemo?: MnemoModel;
    cycle?: number;
    inverted?: boolean;
}

export interface ExerciseCardModel extends CardModel {
    exercise?: ExerciseModel;
    explanation?: ExplanationModel;
    is_first_topic_show?: boolean;
}

export interface ExplanationCardModel extends CardModel {
    explanation: ExplanationModel;
    is_first_topic_show?: boolean;
}

export interface TopicCardModel extends CardModel {
    // topic: TopicModel[];
}

/**
 * Card enums
 */

export enum EvaluationMark {
    COMPLETE_BLACKOUT,
    AGAIN,
    HARD,
    GOOD,
    EASY,
    PERFECT
}

export enum CardType {
    EXPLANATION = 1,
    VOCABULARY,
    EXERCISE,
    TOPIC_OVERVIEW,
}
